import { CareerViewModel } from '@common/model/catalog/career';
import { CareerDictionaryResponse } from './response';

export const careerDictionaryDataAdaptor = (response: CareerViewModel[]): CareerDictionaryResponse => {
  return response.reduce((acc, career) => {
    acc[career.id] = career;
    return acc;
  }, {});
};
